import { render } from "./GemMechanism16.vue?vue&type=template&id=e97bfa94&scoped=true"
import script from "./GemMechanism16.vue?vue&type=script&lang=js"
export * from "./GemMechanism16.vue?vue&type=script&lang=js"

import "./GemMechanism16.vue?vue&type=style&index=0&id=e97bfa94&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e97bfa94"]])

export default __exports__